exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2n2o{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_2n2o",
	"root": "_2n2o"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/ContactForm/ContactForm.css
// module id = 209
// module chunks = 0